import React, { useState } from 'react';
import {
  DropdownOption,
  Dropdown,
  Button,
  TextInput,
  TableRow,
  TableCell,
  Icon,
} from '@vp/swan';
import { usePageModsContext } from '../../contexts/PageModsProvider';
import {
  ITEM_SCOPE,
  ITEM_GROUP_SCOPE,
  ORDER_SCOPE,
  PAGE_SCOPE,
} from '../../../constants/pageModScopes';

export function PageModEntry() {
  const {
    pageLevelPageUxMods,
    setPageLevelPageUxMods,
    itemLevelPageUxMods,
    setItemLevelPageUxMods,
    orderLevelPageUxMods,
    setOrderLevelPageUxMods,
    itemGroupLevelPageUxMods,
    setItemGroupLevelPageUxMods,
  } = usePageModsContext();
  const [newFamily, setNewFamily] = useState<string>('');
  const [newId, setNewId] = useState<string>('');
  const [newScope, setNewScope] = useState<string>(ITEM_SCOPE);
  const availableScopes: string[] = [
    ITEM_SCOPE,
    PAGE_SCOPE,
    ORDER_SCOPE,
    ITEM_GROUP_SCOPE,
  ];

  const onScopeSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setNewScope(event.target.value);
  };

  const handleFamilyTextInput = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newFamilyInput = event.target.value.trim();
    if (newFamilyInput !== newFamily) {
      setNewFamily(newFamilyInput);
    }
  };

  const handleIdTextInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newIdInput = (event.target as HTMLInputElement).value.trim();
    if (newIdInput !== newId) {
      setNewId(newIdInput);
    }
  };
  const addMod = () => {
    if (newScope === ITEM_SCOPE) {
      // add new item-level page mod
      setItemLevelPageUxMods([
        ...itemLevelPageUxMods,
        {
          modRef: {
            family: newFamily,
            id: newId,
          },
          scope: newScope,
          enabled: true,
        },
      ]);
    }

    if (newScope === PAGE_SCOPE) {
      // add new page-level page mod
      setPageLevelPageUxMods([
        ...pageLevelPageUxMods,
        {
          modRef: {
            family: newFamily,
            id: newId,
          },
          scope: newScope,
          enabled: true,
        },
      ]);
    }

    if (newScope === ORDER_SCOPE) {
      // add new order-level page mod
      setOrderLevelPageUxMods([
        ...orderLevelPageUxMods,
        {
          modRef: {
            family: newFamily,
            id: newId,
          },
          scope: newScope,
          enabled: true,
        },
      ]);
    }

    if (newScope === ITEM_GROUP_SCOPE) {
      // add new order-level page mod
      setItemGroupLevelPageUxMods([
        ...itemGroupLevelPageUxMods,
        {
          modRef: {
            family: newFamily,
            id: newId,
          },
          scope: newScope,
          enabled: true,
        },
      ]);
    }

    setNewFamily('');
    setNewId('');
    setNewScope(ITEM_SCOPE);
  };

  return (
    <TableRow>
      <TableCell>
        <TextInput
          onChange={handleFamilyTextInput}
          value={newFamily}
          aria-labelledby="mod-family-label"
        />
      </TableCell>
      <TableCell>
        <TextInput
          onChange={handleIdTextInput}
          value={newId}
          aria-labelledby="mod-id-label"
        />
      </TableCell>
      <TableCell id="mod-scope-label">
        <Dropdown
          onChange={onScopeSelect}
          value={newScope}
          aria-labelledby="mod-scope-label"
        >
          {availableScopes.map((scope) => (
            <DropdownOption value={scope} key={scope}>
              {scope}
            </DropdownOption>
          ))}
        </Dropdown>
      </TableCell>
      <TableCell>
        <Button
          compactMode
          buttonShape="round"
          skin="primary"
          onClick={() => {
            addMod();
          }}
        >
          <Icon alt="Add mod" iconType="plus" />
        </Button>
      </TableCell>
    </TableRow>
  );
}
